import styled from 'styled-components';

import Button from './Button';

export const KycConfirmButton = styled(Button)`
  font-family: var(--fontRegular) !important;
  font-size: 14px;
  line-height: 1.43;
  width: 160px;
  height: 40px;
  border-radius: 0;
  box-shadow: none;
  &:hover {
    background-color: var(--brand-bg-hover);
  }
  &.disable {
    opacity: 0.8;
    pointer-events: none;
    cursor: none;
  }
`;
export default KycConfirmButton;
